export default __webpack_public_path__ + "static/media/PoorStory-Regular.bec8ef9a.ttf";